<template>
	<slot :isLoggedIn="isLoggedIn" :urls="getAppUrls()" :user="user" :currentUrl="route.path" />
</template>

<script setup>
	const nuxtApp = useNuxtApp();
	const route = nuxtApp._route;
	const auth = useAuth();
	const {getAppUrls} = useApiRoutes();
	const user = computed(() => auth.getUser());
	const isLoggedIn = computed(() => auth.isLoggedIn());
</script>
